<template>
    <div>
        <Header />
        <div class="top-holder">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="top-left">
                            <h6>Making living sustainable, affordable, accessible and rewarding.</h6>
                            <h3>Shelta - Covering Africa, One Household at a Time</h3>
                            <p>Shelta simplifies rent and household management for families, landlords, and organizations, empowering communities across Africa with reliable, stress-free housing solutions.</p>

                            <div class="join-btn d-none d-sm-block">
                                <button class="btn" @click="moveToRouteName('/login')">Join as Landlord</button>
                                <button class="btn no-button" @click="moveToRouteName('/login')">Join as Household</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <img class="w-100" src="../assets/home/home-new1.png" alt="home">

                        </div>
                    </div>
                    <div class="join-btn container d-block d-sm-none mt-5" style="text-align: center;">
                        <button class="btn mt-3" @click="moveToRouteName('/login')">Join as Landlord</button>
                        <button class="btn no-button mt-3" @click="moveToRouteName('/login')">Join as Household</button>
                    </div>
                </div>

                <div class="count-holder">
                    <div class="row justify-content-around">
                        <div class="count-item">
                            <h2>90%</h2>
                            <p>Reduction in rent stress</p>
                        </div>
                        <div class="count-item">
                            <h2>10K+</h2>
                            <p>Households on the waitlist</p>
                        </div>
                        <div class="count-item">
                            <h2>300+</h2>
                            <p>Landlords Onboarded</p>
                        </div>
                        <div class="count-item">
                            <h2>50+</h2>
                            <p>Corporate & Merchant Partners</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="holding container">    
            <div class="partners-holder">
                <h6>Powered by trusted partners and organizations building better living across Africa.</h6>
                <div class=" mt-5 scroller">
                    <ul class="scroller-inner">
                        <li>
                            <img src="../assets/brands/ppdc.png" alt="ppdc">
                        </li>
                        <li>
                            <img src="../assets/brands/dojan.png" alt="dojan">
                        </li>
                        <li>
                            <img src="../assets/brands/squad.png" alt="squad">
                        </li>
                        <li>
                            <img src="../assets/brands/first-central.png" alt="firstbank">
                        </li>
                        <li>
                            <img src="../assets/brands/interswitch.png" alt="interswitch">
                        </li>
                        <li>
                            <img src="../assets/brands/hxafrica.png" alt="hxafrica">
                        </li>
                        <li>
                            <img src="../assets/brands/tree.png" alt="tree">
                        </li>
                    </ul>
                    
                </div>
            </div>

            <div class="solved-problem">
                <h3>The Problem We Solve</h3>
                <h6>Shelta bridges the gap between families, landlords, and organizations with simpler, reliable housing solutions.</h6>

                <div class="problem-cover">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M27.5 25C31.0899 25 34 24.1046 34 23C34 21.8954 31.0899 21 27.5 21C23.9101 21 21 21.8954 21 23C21 24.1046 23.9101 25 27.5 25Z" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M34 27.5C34 28.6046 31.0899 29.5 27.5 29.5C23.9101 29.5 21 28.6046 21 27.5" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M34 23V31.8C34 33.015 31.0899 34 27.5 34C23.9101 34 21 33.015 21 31.8V23" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M20.5 18C24.0899 18 27 17.1046 27 16C27 14.8954 24.0899 14 20.5 14C16.9101 14 14 14.8954 14 16C14 17.1046 16.9101 18 20.5 18Z" stroke="#0033EA" stroke-width="1.5"/>
                                        <path d="M18 23C16.1082 22.7698 14.3699 22.1745 14 21M18 28C16.1082 27.7698 14.3699 27.1745 14 26" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M18 33C16.1082 32.7698 14.3699 32.1745 14 31V16" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M27 18V16" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round"/>
                                    </svg>

                                </span>
                                <h5>Rent stress and unreliable services</h5>
                                <p>Families struggle with huge upfront rent and unreliable daily services that disrupt peaceful living.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M14.0156 27C16.2152 27 17.9983 28.7831 17.9983 30.9827" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M14.0156 20.9983C15.8755 20.9983 17.4375 19.7235 17.8757 18" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M30 17.0156C30 19.1959 31.769 20.9671 33.9423 20.9979" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M21.8787 21.8789C21.3358 22.4218 21 23.1718 21 24.0002C21 25.657 22.3431 27.0002 24 27.0002C24.8284 27.0002 25.5784 26.6644 26.1213 26.1215" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M15 15L33 33" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M33.8931 27C33.0742 27 32.3144 27.253 31.6875 27.6851" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M33.541 29.541C34 28.6386 34 27.278 34 25V23C34 20.1716 34 18.7574 33.1213 17.8787C32.2426 17 30.8284 17 28 17H21M30.9305 30.9305C30.168 31 29.2143 31 28 31H20C17.1716 31 15.7574 31 14.8787 30.1213C14 29.2426 14 27.8284 14 25V23C14 20.1716 14 18.7574 14.8787 17.8787C15.3801 17.3772 16.056 17.162 17.0695 17.0695" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h5>Unpaid rent. Poor maintenance.</h5>
                                <p>Landlords lose billions yearly due to late rent payments and poor property care from tenants and agents.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="problem-item">
                                <span>
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                        <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                        <path d="M24.8924 14.8098L33.4876 21.5955C33.8112 21.851 34 22.2405 34 22.6528C34 23.3969 33.3969 24 32.6528 24H32V27.5C32 30.3284 32 31.7426 31.1213 32.6213C30.2426 33.5 28.8284 33.5 26 33.5H22C19.1716 33.5 17.7574 33.5 16.8787 32.6213C16 31.7426 16 30.3284 16 27.5V24H15.3472C14.6032 24 14 23.3969 14 22.6528C14 22.2405 14.1888 21.851 14.5124 21.5955L23.1076 14.8098C23.3617 14.6091 23.6761 14.5 24 14.5C24.3239 14.5 24.6383 14.6091 24.8924 14.8098Z" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26.5 33.5V29C26.5 28.0654 26.5 27.5981 26.299 27.25C26.1674 27.022 25.978 26.8326 25.75 26.701C25.4019 26.5 24.9346 26.5 24 26.5C23.0654 26.5 22.5981 26.5 22.25 26.701C22.022 26.8326 21.8326 27.022 21.701 27.25C21.5 27.5981 21.5 28.0654 21.5 29V33.5" stroke="#0033EA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h5>Housing stress affects productivity.</h5>
                                <p>Employers and cooperatives face reduced performance as staff deal with housing pressures and instability.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="household-holder">
                <h3>Better Living, Secure Income, Stronger Communities</h3>
                <h6>From flexible rent to reliable property care and staff housing support, Shelta connects everyone to a better way of living.</h6>

                <div class="hosuehold-coever-2">
                    <div class="row">
                        <div class="col-md-6">
                            <div>
                                <h5>For Households</h5>
                                <div class="row">
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M27 19.5C27 19.5 27.5 19.5 28 20.5C28 20.5 29.5882 18 31 17.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M34 19C34 21.7614 31.7614 24 29 24C26.2386 24 24 21.7614 24 19C24 16.2386 26.2386 14 29 14C31.7614 14 34 16.2386 34 19Z" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M25 33.751V34.251H23V33.751H25ZM16.1807 33.0898C16.6874 33.3695 17.3118 33.535 18.1426 33.6289C19.1241 33.7398 20.3654 33.749 22 33.75V34.25C20.3701 34.2491 19.0994 34.2403 18.0869 34.126C17.1858 34.0242 16.4695 33.8345 15.8691 33.4854L16.1807 33.0898ZM32.1299 33.4854C31.5297 33.8342 30.8139 34.0242 29.9131 34.126C28.9006 34.2403 27.6299 34.2491 26 34.25V33.75C27.6347 33.749 28.876 33.7398 29.8574 33.6289C30.6878 33.535 31.3117 33.3693 31.8184 33.0898L32.1299 33.4854ZM14.251 26.501C14.2521 28.0254 14.2632 29.1817 14.3799 30.0967C14.4781 30.8673 14.6501 31.4468 14.9404 31.918L14.5635 32.2539C14.1932 31.6868 13.9921 31.0097 13.8838 30.1602C13.7627 29.2103 13.752 28.0207 13.751 26.501H14.251ZM34.249 26.501C34.248 28.0207 34.2373 29.2103 34.1162 30.1602C34.0078 31.0099 33.8061 31.6867 33.4355 32.2539L33.0586 31.918C33.349 31.4467 33.5218 30.8675 33.6201 30.0967C33.7368 29.1816 33.7479 28.0253 33.749 26.501H34.249ZM14.9404 20.084C14.65 20.5552 14.4782 21.1346 14.3799 21.9053C14.2632 22.8202 14.2521 23.9768 14.251 25.501H13.751C13.752 23.9817 13.7627 22.7924 13.8838 21.8428C13.9922 20.9929 14.1929 20.3153 14.5635 19.748L14.9404 20.084ZM20.5625 18.2598C19.3928 18.2732 18.4721 18.3122 17.7217 18.4307C17.0954 18.5295 16.5979 18.681 16.1807 18.9111L15.8672 18.5146C16.3657 18.2247 16.9451 18.0468 17.6436 17.9365C18.4311 17.8122 19.3838 17.7722 20.5596 17.7588L20.5625 18.2598Z" stroke="#555555"/>
                                                <path d="M22 30H23.5" stroke="#555555" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M26.5 30H30" stroke="#555555" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14.5 23H22" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Flexible Rent Payment</h4>
                                            <p>Pay rent monthly, quarterly or biannually- No more lump sum stress.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M27 19.5C27 19.5 27.5 19.5 28 20.5C28 20.5 29.5882 18 31 17.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M34 19C34 21.7614 31.7614 24 29 24C26.2386 24 24 21.7614 24 19C24 16.2386 26.2386 14 29 14C31.7614 14 34 16.2386 34 19Z" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M25 33.751V34.251H23V33.751H25ZM16.1807 33.0898C16.6874 33.3695 17.3118 33.535 18.1426 33.6289C19.1241 33.7398 20.3654 33.749 22 33.75V34.25C20.3701 34.2491 19.0994 34.2403 18.0869 34.126C17.1858 34.0242 16.4695 33.8345 15.8691 33.4854L16.1807 33.0898ZM32.1299 33.4854C31.5297 33.8342 30.8139 34.0242 29.9131 34.126C28.9006 34.2403 27.6299 34.2491 26 34.25V33.75C27.6347 33.749 28.876 33.7398 29.8574 33.6289C30.6878 33.535 31.3117 33.3693 31.8184 33.0898L32.1299 33.4854ZM14.251 26.501C14.2521 28.0254 14.2632 29.1817 14.3799 30.0967C14.4781 30.8673 14.6501 31.4468 14.9404 31.918L14.5635 32.2539C14.1932 31.6868 13.9921 31.0097 13.8838 30.1602C13.7627 29.2103 13.752 28.0207 13.751 26.501H14.251ZM34.249 26.501C34.248 28.0207 34.2373 29.2103 34.1162 30.1602C34.0078 31.0099 33.8061 31.6867 33.4355 32.2539L33.0586 31.918C33.349 31.4467 33.5218 30.8675 33.6201 30.0967C33.7368 29.1816 33.7479 28.0253 33.749 26.501H34.249ZM14.9404 20.084C14.65 20.5552 14.4782 21.1346 14.3799 21.9053C14.2632 22.8202 14.2521 23.9768 14.251 25.501H13.751C13.752 23.9817 13.7627 22.7924 13.8838 21.8428C13.9922 20.9929 14.1929 20.3153 14.5635 19.748L14.9404 20.084ZM20.5625 18.2598C19.3928 18.2732 18.4721 18.3122 17.7217 18.4307C17.0954 18.5295 16.5979 18.681 16.1807 18.9111L15.8672 18.5146C16.3657 18.2247 16.9451 18.0468 17.6436 17.9365C18.4311 17.8122 19.3838 17.7722 20.5596 17.7588L20.5625 18.2598Z" stroke="#555555"/>
                                                <path d="M22 30H23.5" stroke="#555555" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M26.5 30H30" stroke="#555555" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14.5 23H22" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Reliable Services (Fixr & Sollaa)</h4>
                                            <p>Access vetted electricians, plumbers and solar experts for safe uninterrupted living.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M16 23V27C16 30.2998 16 31.9497 17.0251 32.9749C18.0502 34 19.7002 34 23 34H25C28.2998 34 29.9497 34 30.9749 32.9749C32 31.9497 32 30.2998 32 27V23" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M15 21C15 20.2523 15 19.8785 15.201 19.6C15.3326 19.4176 15.522 19.2661 15.75 19.1608C16.0981 19 16.5654 19 17.5 19H30.5C31.4346 19 31.9019 19 32.25 19.1608C32.478 19.2661 32.6674 19.4176 32.799 19.6C33 19.8785 33 20.2523 33 21C33 21.7477 33 22.1215 32.799 22.4C32.6674 22.5824 32.478 22.7339 32.25 22.8392C31.9019 23 31.4346 23 30.5 23H17.5C16.5654 23 16.0981 23 15.75 22.8392C15.522 22.7339 15.3326 22.5824 15.201 22.4C15 22.1215 15 21.7477 15 21Z" stroke="#555555" stroke-width="1.5" stroke-linejoin="round"/>
                                                <path d="M18 15.7857C18 14.7995 18.7995 14 19.7857 14H20.1429C22.2731 14 24 15.7269 24 17.8571V19H21.2143C19.4391 19 18 17.5609 18 15.7857Z" stroke="#555555" stroke-width="1.5" stroke-linejoin="round"/>
                                                <path d="M30 15.7857C30 14.7995 29.2005 14 28.2143 14H27.8571C25.7269 14 24 15.7269 24 17.8571V19H26.7857C28.5609 19 30 17.5609 30 15.7857Z" stroke="#555555" stroke-width="1.5" stroke-linejoin="round"/>
                                                <path d="M24 23V34" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </span>
                                        <div>
                                            <h4>COVA Rewards & Credit</h4>
                                            <p>Earn points and build credit from daily household spending.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M31.4626 15.9942C28.7809 14.3492 26.4404 15.0121 25.0344 16.068C24.4578 16.501 24.1696 16.7174 24 16.7174C23.8304 16.7174 23.5422 16.501 22.9656 16.068C21.5596 15.0121 19.2191 14.3492 16.5374 15.9942C13.0181 18.1529 12.2217 25.2748 20.3395 31.2833C21.8857 32.4278 22.6588 33 24 33C25.3412 33 26.1143 32.4278 27.6605 31.2833C35.7783 25.2748 34.9819 18.1529 31.4626 15.9942Z" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M24 21V27M21 24H27" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Peace of Mind</h4>
                                            <p>Get legal support, exclusive discounts, and emergency help for complete protection.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="household-image">
                                <img  class="w-100" src="../assets/home/household.png" alt="household">

                            </div>
                        </div>
                        <div class="primary-button house-join-mobile">
                            <button class="btn" @click="moveToRouteName('/login')">Join Shelta Household</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="household-holder">
                <div class="hosuehold-coever" style="background: #FFFFFF !important;">
                    <div class="row">
                        
                        <div class="col-md-6">
                            <div class="household-image">
                                <img class="w-100" src="../assets/home/landordpix.png" alt="landlord">


                            </div>
                        </div>
                        <div class="col-md-6">
                            <div>
                                <h5>For Landlords</h5>
                                <div class="row">
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M27 19.5C27 19.5 27.5 19.5 28 20.5C28 20.5 29.5882 18 31 17.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M34 19C34 21.7614 31.7614 24 29 24C26.2386 24 24 21.7614 24 19C24 16.2386 26.2386 14 29 14C31.7614 14 34 16.2386 34 19Z" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M25 33.751V34.251H23V33.751H25ZM16.1807 33.0898C16.6874 33.3695 17.3118 33.535 18.1426 33.6289C19.1241 33.7398 20.3654 33.749 22 33.75V34.25C20.3701 34.2491 19.0994 34.2403 18.0869 34.126C17.1858 34.0242 16.4695 33.8345 15.8691 33.4854L16.1807 33.0898ZM32.1299 33.4854C31.5297 33.8342 30.8139 34.0242 29.9131 34.126C28.9006 34.2403 27.6299 34.2491 26 34.25V33.75C27.6347 33.749 28.876 33.7398 29.8574 33.6289C30.6878 33.535 31.3117 33.3693 31.8184 33.0898L32.1299 33.4854ZM14.251 26.501C14.2521 28.0254 14.2632 29.1817 14.3799 30.0967C14.4781 30.8673 14.6501 31.4468 14.9404 31.918L14.5635 32.2539C14.1932 31.6868 13.9921 31.0097 13.8838 30.1602C13.7627 29.2103 13.752 28.0207 13.751 26.501H14.251ZM34.249 26.501C34.248 28.0207 34.2373 29.2103 34.1162 30.1602C34.0078 31.0099 33.8061 31.6867 33.4355 32.2539L33.0586 31.918C33.349 31.4467 33.5218 30.8675 33.6201 30.0967C33.7368 29.1816 33.7479 28.0253 33.749 26.501H34.249ZM14.9404 20.084C14.65 20.5552 14.4782 21.1346 14.3799 21.9053C14.2632 22.8202 14.2521 23.9768 14.251 25.501H13.751C13.752 23.9817 13.7627 22.7924 13.8838 21.8428C13.9922 20.9929 14.1929 20.3153 14.5635 19.748L14.9404 20.084ZM20.5625 18.2598C19.3928 18.2732 18.4721 18.3122 17.7217 18.4307C17.0954 18.5295 16.5979 18.681 16.1807 18.9111L15.8672 18.5146C16.3657 18.2247 16.9451 18.0468 17.6436 17.9365C18.4311 17.8122 19.3838 17.7722 20.5596 17.7588L20.5625 18.2598Z" stroke="#555555"/>
                                                <path d="M22 30H23.5" stroke="#555555" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M26.5 30H30" stroke="#555555" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14.5 23H22" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Guaranteed Rents</h4>
                                            <p>Receive your full annual rent on time while tenants pay Shelta flexibly</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M14 16.5H20.7574C21.553 16.5 22.3161 16.8161 22.8787 17.3787L26 20.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M17 25.5H14" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M20.5 19.5L22.5 21.5C23.0523 22.0523 23.0523 22.9477 22.5 23.5C21.9477 24.0523 21.0523 24.0523 20.5 23.5L19 22C18.1393 22.8607 16.7767 22.9575 15.8029 22.2272L15.5 22" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M17 23V27.5C17 29.3856 17 30.3284 17.5858 30.9142C18.1716 31.5 19.1144 31.5 21 31.5H30C31.8856 31.5 32.8284 31.5 33.4142 30.9142C34 30.3284 34 29.3856 34 27.5V24.5C34 22.6144 34 21.6716 33.4142 21.0858C32.8284 20.5 31.8856 20.5 30 20.5H21.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M27.25 26C27.25 26.9665 26.4665 27.75 25.5 27.75C24.5335 27.75 23.75 26.9665 23.75 26C23.75 25.0335 24.5335 24.25 25.5 24.25C26.4665 24.25 27.25 25.0335 27.25 26Z" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </span>
                                        <div>
                                            <h4>Automated Rent Collection</h4>
                                            <p>Direct, transparent rent payments with instant statements.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M27 33.5C28.3945 33.5 29.0918 33.5 29.6672 33.3619C31.4955 32.9229 32.9229 31.4955 33.3618 29.6672C33.5 29.0918 33.5 28.3945 33.5 27M21 33.5C19.6055 33.5 18.9082 33.5 18.3328 33.3619C16.5045 32.9229 15.0771 31.4955 14.6381 29.6672C14.5 29.0918 14.5 28.3945 14.5 27M21 14.5C19.6055 14.5 18.9082 14.5 18.3328 14.6381C16.5045 15.0771 15.0771 16.5045 14.6381 18.3328C14.5 18.9082 14.5 19.6055 14.5 21M27 14.5C28.3945 14.5 29.0918 14.5 29.6672 14.6381C31.4955 15.0771 32.9229 16.5045 33.3618 18.3328C33.5 18.9082 33.5 19.6055 33.5 21" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M27 21.5C27 19.8432 25.6569 18.5 24 18.5C22.3431 18.5 21 19.8432 21 21.5C21 23.1569 22.3431 24.5 24 24.5C25.6569 24.5 27 23.1569 27 21.5Z" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M29 29.5C29 26.7386 26.7614 24.5 24 24.5C21.2386 24.5 19 26.7386 19 29.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Verified Tenants (KYC)</h4>
                                            <p>Every tenant screened and approved to minimize risk.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M27.5 25C31.0899 25 34 24.1046 34 23C34 21.8954 31.0899 21 27.5 21C23.9101 21 21 21.8954 21 23C21 24.1046 23.9101 25 27.5 25Z" stroke="#555555" stroke-width="1.5"/>
                                                <path d="M34 27.5C34 28.6046 31.0899 29.5 27.5 29.5C23.9101 29.5 21 28.6046 21 27.5" stroke="#555555" stroke-width="1.5"/>
                                                <path d="M34 23V31.8C34 33.015 31.0899 34 27.5 34C23.9101 34 21 33.015 21 31.8V23" stroke="#555555" stroke-width="1.5"/>
                                                <path d="M20.5 18C24.0899 18 27 17.1046 27 16C27 14.8954 24.0899 14 20.5 14C16.9101 14 14 14.8954 14 16C14 17.1046 16.9101 18 20.5 18Z" stroke="#555555" stroke-width="1.5"/>
                                                <path d="M18 23C16.1082 22.7698 14.3699 22.1745 14 21M18 28C16.1082 27.7698 14.3699 27.1745 14 26" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M18 33C16.1082 32.7698 14.3699 32.1745 14 31V16" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M27 18V16" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Advance & Harmonized Rent</h4>
                                            <p>Get paid ahead or align multiple rents to one payout date.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M14 34H34" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M30 21H26C23.518 21 23 21.518 23 24V34H33V24C33 21.518 32.482 21 30 21Z" stroke="#555555" stroke-width="1.5" stroke-linejoin="round"/>
                                                <path d="M27 34H15V17C15 14.518 15.518 14 18 14H24C26.482 14 27 14.518 27 17V21" stroke="#555555" stroke-width="1.5" stroke-linejoin="round"/>
                                                <path d="M15 18H18M15 22H18M15 26H18" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M27 25H29M27 28H29" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M28 34V31" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Shelta Renovate</h4>
                                            <p>Access automated statements and property dashboards anytime.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="right-btn plain-border-button house-join-mobile mt-5">
                            <button class="btn" @click="moveToRouteName('/login')">Become a Shelta Landlords</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="household-holder">
                <div class="hosuehold-coever">
                    <div class="row align-items-center">
                        <div class="col-md-6">
                            <div>
                                <h5>For Organizations</h5>
                                <div class="row">
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M29 15.3378C27.5291 14.487 25.8214 14 24 14C18.4771 14 14 18.4771 14 24C14 29.5228 18.4771 34 24 34C29.5228 34 34 29.5228 34 24C34 23.3151 33.9311 22.6462 33.8 22" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M20 24.5C20 24.5 21.5 24.5 23.5 28C23.5 28 29.0588 18.8333 34 17" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </span>
                                        <div>
                                            <h4>Staff Rent Solutions</h4>
                                            <p>Flexible, employer-backed housing benefits to ease financial stress.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M14 22L23.1076 14.8098C23.3617 14.6091 23.6761 14.5 24 14.5C24.3239 14.5 24.6383 14.6091 24.8924 14.8098L28.5 17.6579V16C28.5 15.4477 28.9477 15 29.5 15H30.5C31.0523 15 31.5 15.4477 31.5 16V20.0263L34 22" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M32 23.5V27.5C32 30.3284 32 31.7426 31.1213 32.6213C30.2426 33.5 28.8284 33.5 26 33.5H22C19.1716 33.5 17.7574 33.5 16.8787 32.6213C16 31.7426 16 30.3284 16 27.5V23.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M27 27.5C26.2005 28.1224 25.1502 28.5 24 28.5C22.8498 28.5 21.7995 28.1224 21 27.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Rent-to-Own & Home Ownership</h4>
                                            <p>Help members and employees move from renting to owning.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M28.4407 33.3478L28.9929 32.6576C29.4781 32.0511 30.5085 32.1 30.9184 32.7488C31.4114 33.5295 32.6292 33.3743 32.9669 32.6562C32.9845 32.6189 32.9405 32.7123 32.9781 32.3892C33.0156 32.0661 33 31.9923 32.9687 31.8448L31.0456 22.7641C30.5623 20.482 30.3206 19.3409 29.4893 18.6704C28.6581 18 27.4848 18 25.1384 18H22.8616C20.5152 18 19.3419 18 18.5107 18.6704C17.6794 19.3409 17.4377 20.482 16.9544 22.7641L15.0313 31.8448C15 31.9923 14.9844 32.0661 15.0219 32.3892C15.0595 32.7123 15.0155 32.6189 15.0331 32.6562C15.3708 33.3743 16.5886 33.5295 17.0817 32.7488C17.4915 32.1 18.5219 32.0511 19.0071 32.6576L19.5593 33.3478C20.2551 34.2174 21.7082 34.2174 22.404 33.3478L22.4908 33.2392C23.2291 32.3165 24.7709 32.3165 25.5092 33.2392L25.596 33.3478C26.2918 34.2174 27.7449 34.2174 28.4407 33.3478Z" stroke="#555555" stroke-width="1.5" stroke-linejoin="round"/>
                                                <path d="M14.4834 21.5C13.8981 20.892 14.0082 20.1089 14.0082 18.1518C14.0082 16.1946 14.0082 15.216 14.5936 14.608C15.1789 14 16.1209 14 18.005 14H29.9952C31.8792 14 32.8213 14 33.4066 14.608C33.9919 15.216 33.9919 16.1946 33.9919 18.1518C33.9919 20.1089 34.1014 20.892 33.5161 21.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M24 22H21" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M26 26H20" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Payroll Integration</h4>
                                            <p>Automated deductions through secure systems.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M16 26.0695C17.0145 26.0695 18.4312 25.7685 19.3194 26.4193L21.0819 27.7108C21.7367 28.1906 22.4458 28.0325 23.1765 27.9178C24.1389 27.7667 25 28.5875 25 29.6562C25 29.9482 22.9272 30.6905 22.6276 30.8316C22.0391 31.1088 21.363 31.0406 20.8302 30.6502L18.8421 29.1934" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M25 29L29.091 27.1096C29.8244 26.854 30.6331 27.0535 31.1797 27.625L31.8505 28.3262C32.0902 28.5768 32.0338 28.9976 31.7375 29.1697L23.8829 33.7315C23.4097 34.0063 22.8514 34.0734 22.3309 33.9179L16 32.0269" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M24 24C24 24 26.1 21.7614 26.1 19C26.1 16.2386 24 14 24 14C24 14 21.9 16.2386 21.9 19C21.9 21.7614 24 24 24 24ZM24 24C24 24 27.067 23.9316 29 21.9592C30.933 19.9867 31 16.8571 31 16.8571C31 16.8571 29.7305 16.8854 28.3103 17.4309M24 24C24 24 20.933 23.9316 19 21.9592C17.067 19.9867 17 16.8571 17 16.8571C17 16.8571 18.2694 16.8854 19.6897 17.4309" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                        </span>
                                        <div>
                                            <h4>Welfare & Retention</h4>
                                            <p>Boost staff satisfaction, loyalty, and long-term retention.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M18.5 29.5V26.5M23.5 29.5V20.5M28.5 29.5V25.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M33.5 17.5C33.5 19.1568 32.1569 20.5 30.5 20.5C28.8431 20.5 27.5 19.1568 27.5 17.5C27.5 15.8432 28.8431 14.5 30.5 14.5C32.1569 14.5 33.5 15.8432 33.5 17.5Z" stroke="#555555" stroke-width="1.5"/>
                                                <path d="M33.4955 23C33.4955 23 33.5 23.3395 33.5 24C33.5 28.4784 33.5 30.7175 32.1088 32.1088C30.7175 33.5 28.4783 33.5 24 33.5C19.5217 33.5 17.2825 33.5 15.8912 32.1088C14.5 30.7175 14.5 28.4784 14.5 24C14.5 19.5217 14.5 17.2825 15.8912 15.8913C17.2825 14.5 19.5217 14.5 24 14.5L25 14.5" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Analytics Dashboard</h4>
                                            <p>HR and management insights into housing stability and impact.</p>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <span>
                                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="46" height="46" rx="23" fill="#F9FAFB"/>
                                                <rect x="1" y="1" width="46" height="46" rx="23" stroke="#F9FAFB" stroke-width="2"/>
                                                <path d="M18.0894 27C17.711 26.1494 17.5 25.2031 17.5 24.2059C17.5 20.5023 20.4102 17.5 24 17.5C27.5899 17.5 30.5 20.5023 30.5 24.2059C30.5 25.2031 30.289 26.1494 29.9106 27" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
                                                <path d="M24 14V15" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M34 24H33" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M15 24H14" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M31.0743 16.9297L30.3672 17.6368" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M17.6368 17.6368L16.9297 16.9297" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M26.5155 31.3074C27.5259 30.9806 27.9311 30.0558 28.0451 29.1256C28.0791 28.8477 27.8505 28.6172 27.5705 28.6172L20.4754 28.6174C20.1858 28.6174 19.9532 28.8632 19.9878 29.1507C20.0994 30.0791 20.3812 30.7573 21.452 31.3074M26.5155 31.3074C26.5155 31.3074 21.6283 31.3074 21.452 31.3074M26.5155 31.3074C26.394 33.2524 25.8323 34.0227 24.0053 34.0011C22.0511 34.0372 21.6016 33.0851 21.452 31.3074" stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <div>
                                            <h4>Brand Visibility</h4>
                                            <p>Your organization becomes part of Shelta’s household community.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="household-image">
                                <img class="w-100" src="../assets/home/organizationpix.png" alt="organization">
                            </div>
                        </div>
                        <div class="primary-button house-join-mobile ">
                            <button class="btn" @click="moveToRouteName('/login')">Join Shelta Cooperative</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="household-holder">
                <h3>How Shelta Works</h3>
                <h6>Get started in minutes — Shelta makes housing and rent management simple for everyone.</h6>

                <div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="shelta-works box-1">
                                        <div class="text-left mb-4">
                                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="64" height="64" rx="32" fill="white"/>
                                                <path d="M45.3307 32.5013C45.3307 39.865 39.3611 45.8346 31.9974 45.8346C24.6336 45.8346 18.6641 39.865 18.6641 32.5013C18.6641 25.1375 24.6336 19.168 31.9974 19.168C39.3611 19.168 45.3307 25.1375 45.3307 32.5013Z" stroke="#0033EA" stroke-width="2"/>
                                                <path d="M35.6693 29.1667C35.6693 31.1917 34.0277 32.8333 32.0026 32.8333C29.9775 32.8333 28.3359 31.1917 28.3359 29.1667C28.3359 27.1416 29.9775 25.5 32.0026 25.5C34.0277 25.5 35.6693 27.1416 35.6693 29.1667Z" stroke="#0033EA" stroke-width="2"/>
                                                <path d="M23.3359 41.8346L24.0831 40.527C25.2701 38.45 27.479 37.168 29.8715 37.168H34.1338C36.5262 37.168 38.7351 38.45 39.922 40.527L40.6692 41.8346" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        <div>
                                            <h1>Create Your Profile</h1>
                                            <h2>Choose your role - household, landlord, or organization.</h2>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="col-md-2 m-auto">
                                    <span>
                                        <i class="fa fa-chevron-right" :class="isMobile ? 'fa-chevron-down' : ''"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="shelta-works box-2">
                                        <div class="text-left mb-4">
                                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="64" height="64" rx="32" fill="white"/>
                                                <path d="M30.6641 24.5H43.9974" stroke="#FFB100" stroke-width="2" stroke-linecap="round"/>
                                                <path d="M30.6641 32.5H43.9974" stroke="#FFB100" stroke-width="2" stroke-linecap="round"/>
                                                <path d="M30.6641 40.5H43.9974" stroke="#FFB100" stroke-width="2" stroke-linecap="round"/>
                                                <path d="M20 26.3558C20 26.3558 21.3333 27.2249 22 28.4987C22 28.4987 24 23.4987 26.6667 21.832" stroke="#FFB100" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M20 41.0239C20 41.0239 21.3333 41.8929 22 43.1667C22 43.1667 24 38.1667 26.6667 36.5" stroke="#FFB100" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                        </div>
                                        <div>
                                            <h1>Activate Your Plan</h1>
                                            <h2>Pick Flexible Rent, Guaranteed Rent, or Corporate Support.</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 m-auto">
                                    <span>
                                        <i class="fa fa-chevron-right" :class="isMobile ? 'fa-chevron-down' : ''"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="shelta-works box-3">
                                <div class="text-left mb-4">
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="64" height="64" rx="32" fill="white"/>
                                        <path d="M35.3333 31.832C35.3333 31.832 32 34.4987 32 39.1654" stroke="#33CCB7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M29.4199 28.584C31.0857 26.9183 31.0857 24.2175 29.4199 22.5518C26.9065 20.0383 21.377 20.541 21.377 20.541C21.377 20.541 20.8743 26.0706 23.3877 28.584C25.0535 30.2497 27.7542 30.2497 29.4199 28.584Z" stroke="#33CCB7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M35.7349 31.4292C37.1627 32.8569 39.4777 32.8569 40.9054 31.4292C43.0598 29.2748 42.6289 24.5352 42.6289 24.5352C42.6289 24.5352 37.8893 24.1043 35.7349 26.2587C34.3071 27.6865 34.3071 30.0013 35.7349 31.4292Z" stroke="#33CCB7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M29.3359 29.168C29.3359 29.168 32.0026 32.5013 32.0026 39.167" stroke="#33CCB7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M44 44.5013C41.0683 41.2308 36.7788 39.168 32 39.168C27.2212 39.168 22.9318 41.2308 20 44.5013" stroke="#33CCB7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div>
                                    <h1>Grow with Shelta</h1>
                                    <h2>Earn rewards, enjoy peace of mind, and build your community.</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="household-holder client-say-holder ">
            <h3>What Our Users Say</h3>
            <h6>Real experiences from families, landlords, and organizations who found peace, reliability, and community with Shelta.</h6>

            <div class="container mt-5">
                <div class="row">
                    <div class="col-md-6">
                        <div class="users-say">
                            <p>“Before Shelta, rent delays were a nightmare. Now I receive payments right on time - every time. Managing my property has never been this smooth.”</p>
                            <div class="row customer-say-item">
                                <div class="pr-2">
                                    <img src="../assets/icons/profile-icon.svg" alt="icon">
                                </div>
                                <div>
                                    <h4>Alhaji Hassan Bako</h4>
                                    <small>Abuja, Nigeria.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="users-say">
                            <p>“Partnering with Shelta helped our staff focus better. No more housing worries or emergency rent requests. It’s real impact we can measure.”</p>
                            <div class="row customer-say-item">
                                <div class="pr-2">
                                    <img src="../assets/icons/profile-icon.svg" alt="icon">
                                </div>
                                <div>
                                    <h4>Ada Nwosu</h4>
                                    <small>Anambra, Nigeria.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="users-say">
                            <p>“As a young professional, Shelta gave me flexibility I never had. I can finally rent a good home without all the stress and pressure.”</p>
                            <div class="row customer-say-item">
                                <div class="pr-2">
                                    <img src="../assets/icons/profile-icon.svg" alt="icon">
                                </div>
                                <div>
                                    <h4>Adebayo Emmanuel</h4>
                                    <small>Anambra, Nigeria.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="users-say">
                            <p>“Paying yearly rent used to drain us. Shelta made it simple now we pay monthly and still have enough for family needs. It’s the peace of mind we prayed for.”</p>
                            <div class="row customer-say-item">
                                <div class="pr-2">
                                    <img src="../assets/icons/profile-icon.svg" alt="icon">
                                </div>
                                <div>
                                    <h4>Grace & Chukwuemeka Eze</h4>
                                    <small>Ibadan, Nigeria.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="household-holder container sip-holder">
            <h3>Shelta Impact Projects (SIP)</h3>
            <h6>
                Beyond housing, we're building stronger communities through education, support for vulnerable households, and grassroots partnerships across Africa.
            </h6>
            <div class="row">
                <div class="col-md-4">
                    <div class="sip-item">
                        <div>
                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                <path d="M35.9974 18.668L36.7157 21.8567C37.325 24.5615 39.4371 26.6737 42.1419 27.283L45.3307 28.0013L42.1419 28.7196C39.4371 29.3289 37.325 31.441 36.7157 34.1458L35.9974 37.3346L35.2791 34.1458C34.6698 31.441 32.5577 29.3289 29.8529 28.7196L26.6641 28.0013L29.8529 27.283C32.5575 26.6737 34.6698 24.5615 35.2791 21.8567L35.9974 18.668Z" stroke="#0033EA" stroke-width="2" stroke-linejoin="round"/>
                                <path d="M25.3307 32L25.8438 34.2777C26.279 36.2096 27.7877 37.7184 29.7197 38.1536L31.9974 38.6667L29.7197 39.1797C27.7877 39.6149 26.279 41.1236 25.8438 43.0556L25.3307 45.3333L24.8176 43.0556C24.3824 41.1236 22.8737 39.6149 20.9418 39.1797L18.6641 38.6667L20.9418 38.1536C22.8737 37.7184 24.3824 36.2097 24.8176 34.2777L25.3307 32Z" stroke="#0033EA" stroke-width="2" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <h4>Super Kids</h4>
                            <p>STEM, language, and talent programs inspiring the next generation.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="sip-item">
                        <div>
                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                <path d="M33.1873 19.7451L44.6475 28.7927C45.079 29.1333 45.3307 29.6527 45.3307 30.2024C45.3307 31.1946 44.5266 31.9987 43.5345 31.9987H42.6641V36.6654C42.6641 40.4366 42.6641 42.3222 41.4925 43.4938C40.3209 44.6654 38.4353 44.6654 34.6641 44.6654H29.3307C25.5595 44.6654 23.6739 44.6654 22.5023 43.4938C21.3307 42.3222 21.3307 40.4366 21.3307 36.6654V31.9987H20.4603C19.4683 31.9987 18.6641 31.1946 18.6641 30.2024C18.6641 29.6527 18.9158 29.1333 19.3473 28.7927L30.8075 19.7451C31.1463 19.4776 31.5655 19.332 31.9974 19.332C32.4293 19.332 32.8485 19.4776 33.1873 19.7451Z" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M35.3307 44.6654V38.6654C35.3307 37.4192 35.3307 36.7962 35.0627 36.332C34.8873 36.028 34.6347 35.7755 34.3307 35.6C33.8666 35.332 33.2435 35.332 31.9974 35.332C30.7513 35.332 30.1282 35.332 29.6641 35.6C29.3601 35.7755 29.1075 36.028 28.932 36.332C28.6641 36.7962 28.6641 37.4192 28.6641 38.6654V44.6654" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <h4>COVER</h4>
                            <p>Providing housing assistance and support services for vulnerable households across Africa.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="sip-item">
                        <div>
                            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="62" height="62" rx="31" fill="#F9FAFB"/>
                                <rect x="1" y="1" width="62" height="62" rx="31" stroke="#F9FAFB" stroke-width="2"/>
                                <path d="M34.1165 42.6249C32.8506 43.5714 31.1442 43.5714 29.8783 42.6249C26.1166 39.812 18.6641 33.381 18.6641 27.5939C18.6641 23.7688 21.4711 20.668 25.3307 20.668C27.3307 20.668 29.3307 21.3346 31.9974 24.0013C34.6641 21.3346 36.6641 20.668 38.6641 20.668C42.5237 20.668 45.3307 23.7688 45.3307 27.5939C45.3307 29.045 44.8622 30.5365 44.1007 32.0013" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M34.6641 37.3346H39.3307M39.3307 37.3346H43.9974M39.3307 37.3346V32.668M39.3307 37.3346V42.0013" stroke="#0033EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <h4>Community Projects</h4>
                            <p>Grassroots partnerships for education, repairs, and empowerment.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="plain-border-button mt-4">
                <button class="btn" disabled>Support Impact Projects</button>
            </div>
        </div>


        <div class="household-holder container">
            <h3>Special Launch Pricing</h3>

            <div class="mt-5">
                <div class="row">
                    <div class="col-md-4">
                        <div class="pricing-item">
                            <!-- <div class="top-options">
                                <h5>Most popular</h5>
                                <button class="btn">Limited Offer</button>
                            </div> -->
                            <h1>Household</h1>
                            <h2>₦20,000</h2>
                           <div class="price-discount">
                                <h6>₦100,000</h6>
                                <span>80% off</span>
                           </div>

                           <p>Live better with flexible rent and reliable home maintenance services.</p>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Monthly Rent Options</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Access to verified service professionals</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>24/7 maintenance & emergency support</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Shelta rewards & credit points</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>and lots more...</h4>
                           </div>
                           <!-- <div class="plain-border-button mt-4">
                                <button class="btn">Get Started for free</button>
                           </div> -->
                           <div class="primary-button">
                            <button class="btn" @click="moveToRouteName('/login')">Get Household Plan</button>
                           </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="pricing-item">
                            <div class="top-options">
                                <h5>Most popular</h5>
                                <button class="btn">Limited Offer</button>
                            </div>
                            <h1>Landlord Plan</h1>
                            <h2>FREE</h2>
                           <!-- <div class="price-discount">
                                <h6>₦100,000</h6>
                                <span>80% off</span>
                           </div> -->

                           <p style="margin-top: 36px;">Guaranteed rent and seamless property management.</p>
                           <div class="d-flex">
                            <span class="pr-2">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                    <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <h4>Property maintenance & reporting</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Tenant verification support</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Guaranteed monthly payments</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Shelta rewards & credit points</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Tand lots more...</h4>
                           </div>
                           <div class="plain-border-button mt-4">
                                <button class="btn" @click="moveToRouteName('/login')">Get Started for free</button>
                           </div>
                           <!-- <div class="primary-button">
                            <button class="btn">Get Started for free</button>
                           </div> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="pricing-item">
                            <div class="top-options">
                                <!-- <h5>Most popular</h5> -->
                                <h5></h5>
                                <button class="btn">Limited Offer</button>
                            </div>
                            <h1>Cooperate Plan</h1>
                            <h2>FREE</h2>
                           <!-- <div class="price-discount">
                                <h6>₦100,000</h6>
                                <span>80% off</span>
                           </div> -->

                           <p style="margin-top: 36px;">Support your staff with housing that reduces stress and improves productivity.</p>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Corporate housing programs</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Employee rent benefits</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Integrated payroll deductions</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>Partner support dashboard</h4>
                           </div>
                           <div class="d-flex">
                                <span class="pr-2">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#F5F8FF"/>
                                        <path d="M26 15.0818V16.0018C25.9988 18.1582 25.3005 20.2565 24.0093 21.9836C22.7182 23.7108 20.9033 24.9743 18.8354 25.5857C16.7674 26.1971 14.5573 26.1237 12.5345 25.3764C10.5117 24.6291 8.78465 23.2479 7.61096 21.4389C6.43727 19.6299 5.87979 17.4899 6.02168 15.3381C6.16356 13.1864 6.99721 11.1381 8.39828 9.49889C9.79935 7.85964 11.6928 6.7172 13.7962 6.24196C15.8996 5.76673 18.1003 5.98415 20.07 6.86182" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M26 8L16 18.01L13 15.01" stroke="#7593FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <h4>and lots more...</h4>
                           </div>
                           <div class="plain-border-button mt-4">
                                <button class="btn" @click="moveToRouteName('/login')">Get Started for free</button>
                           </div>
                           <!-- <div class="primary-button">
                            <button class="btn">Get Started for free</button>
                           </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="letsbuild-holder">
                <div class="row " style="align-items: center;">
                    <div class="col-md-6">
                        <div class="letsbuild-item">
                            <h1>Let’s Build Reliable, Stress-Free Living Together.</h1>
                            <p>From families and landlords to organizations, Shelta connects everyone to better housing experiences and reliable home support.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="w-100" src="../assets/home/new-landing-bottoming.png" alt="last">
                    </div>
                </div>
                <div class="primary-button">
                    <button class="btn" @click="moveToRouteName('/login')">Get started with Shelta</button>
                </div>
            </div>
        </div>
        <FooterMain />
    </div>
</template>

<script>
import FooterMain from "../views/FooterMain";
import Header from "../views/Header";
export default {
  name: "Landing",
  components: {
    Header,
    FooterMain,
    // HomePart,
    // PromoGif
  },
  data() {
    return {
        // theClient: "landlord",
    //   windowWidth: window.innerWidth
        isMobile: false,
    };
  },
    //   computed: {
    //     isMobile(): boolean {
    //       return this.windowWidth < 768; // Adjust breakpoint as needed
    //     }
    //   },
  created() {
    // Detect on load
    this.checkScreen();
    // Detect on resize
    window.addEventListener("resize", this.checkScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  mounted() {
    // this.checkLogger();
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768; // your breakpoint
    },
    moveToRouteName(route) {
        console.log("Route", route)
        this.$router
          .push({
            path: route
          })
          .catch(() => {});
    }
  },
  watch: {}
};
</script>


<style lang="scss" scoped>

.top-holder {
    margin-top: 6rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
    background: url(../assets/home/netbg.png);
    // background: linear-gradient(270deg, #E0F2F7 0%, #F0F8FF 50%, #FFFFFF 100%), url(../assets/home/netbg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    position: relative;
}
.top-holder::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.95); 
    // background-color: linear-gradient(270deg, #E0F2F7 0%, #F0F8FF 50%, #FFFFFF 100%);
}

.top-left {
    h6 {
        background: #FFB100;
        color: #ffffff;
        border-radius: 50px;
        padding: 8px 30px;
        min-height: 35px;
        margin-bottom: 20px;
        font-family: Lato;
        font-weight: 400;
        font-size: 17px;
        line-height: 30px;
        width: fit-content;
        text-align: left;
    }
    h3 {
        font-family: Lato;
        font-weight: 700;
        // font-style: Bold;
        font-size: 48px;
        line-height: 60px;
        text-align: left;
        color: #1A1A1A;
        margin-bottom: 20px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #555555;
        text-align: left;
    }

    .join-btn {
        margin-top: 7rem;
        text-align: left;
        button:first-child {
            background: #0033EA;
            color: #ffffff;
            font-family: Lato;
            font-weight: 500;
            font-size: 16px;
            outline: 0;
            box-shadow: none;
        }
        button:nth-child(2) {
            color: #0033EA;
            // color: blue !important;
            font-family: Lato;
            font-weight: 500;
            font-size: 16px;
            outline: 0;
            box-shadow: none;
        }
    }
}
.join-btn {
        margin-top: 7rem;
        text-align: left;
        button:first-child {
            background: #0033EA;
            color: #ffffff;
            font-family: Lato;
            font-weight: 500;
            font-size: 16px;
            outline: 0;
            box-shadow: none;
        }
        button:nth-child(2) {
            color: #0033EA;
            // color: blue !important;
            font-family: Lato;
            font-weight: 500;
            font-size: 16px;
            outline: 0;
            box-shadow: none;
        }
    }

.count-holder {
    // #EBEBEB
    background: #FFFFFF;
    padding: 16px 24px;
    margin-top: 8rem;
    border-radius: 16px;
    position: relative;
    div:not(:last-child) {
        border-right: 1px solid #EBEBEB;
        padding-right: 4rem;
    }
    h2 {
        font-family: Lato;
        font-weight: 700;
        font-size: 48px;
        // line-height: 40px;
        text-align: center;
        color: #1A1A1A;
        // margin-bottom: 0;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        // line-height: 40;
        color: #555555;
        // margin-bottom: 0;
    }
}

.partners-holder {
    margin-top: 8rem;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 28px;
        color: #1F2223;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        text-align: center;
        color: #555555
    }
}

.scroller {
  /* Set a specific width to define the viewport for the scrolling area */
  width: 100%;
  overflow: hidden; /* Hide the overflowing content */
  /* Optional: adds fade effect at the edges */
  mask: linear-gradient(90deg, transparent, white 20%, white 80%, transparent);
}

/* Inner container that holds the logo lists */
.scroller-inner {
  display: flex;
  /* Combine the two <ul> elements side-by-side */
  width: max-content; 
  /* Run the animation */
  animation: scroll-left 20s linear infinite; /* Adjust duration to control speed */
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Pause the animation on hover */
.scroller:hover .scroller-inner {
  animation-play-state: paused;
}

/* Styles for individual logo items */
.scroller-inner li {
  /* Adjust spacing between logos as needed */
  margin: 0 1rem; 
  /* Ensure images do not wrap to the next line */
  white-space: nowrap;
}

/* Optional: style for the images themselves */
.scroller-inner img {
  max-width: none;
  height: 50px; /* Adjust image height as desired */
}

/* Keyframe animation for the leftward scroll */
@keyframes scroll-left {
  0% {
    /* Start position */
    transform: translateX(0);
  }
  100% {
    /* Move left by 50% of the total width (the width of one <ul>) */
    transform: translateX(-100%); 
  }
}


.solved-problem {
    margin-top: 10rem !important;
}
.household-holder {
    margin-top: 9rem;
    margin-bottom: 6rem;
    h6 {
        margin-bottom: 40px;
    }
}
.household-holder, .solved-problem {
    // margin-top: 4rem;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        color: #1F2223;
        // line-height: 31px;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        text-align: center;
        color: #555555;
        line-height: 28px;
    }
}

.problem-cover {
    text-align: left;
    margin-top: 4rem;
}

.problem-item {
    border-radius: 16px;
    border: 2px solid #EBEBEB;
    padding: 25px;
    min-height: 246px;
    margin-bottom: 15px;
}

.household-image {
    svg {
        width: 100%;
        height: 100%;
    }
}
.hosuehold-coever-2 {
    background: #E6F0FA;
    padding: 60px 36px;
    border-radius: 16px;
    span {
        padding-right: 15px;
    }
    h5 {
        font-family: Lato;
        font-weight: 600;
        color: #1A1A1A;
        text-align: left;
        font-size: 25px;
        margin-bottom: 25px;
        // leading-trim: NONE;
        // line-height: 100%;
        // letter-spacing: 0%;
    }
    h4 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        text-align: left;
        color: #1A1A1A;

    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #555555;
        text-align: left;
    }
}
.hosuehold-coever {
    background: #E6F0FA;
    padding: 60px 36px;
    border-radius: 16px;
    span {
        padding-right: 15px;
    }
    h5 {
        font-family: Lato;
        font-weight: 600;
        color: #1A1A1A;
        text-align: left;
        font-size: 25px;
        margin-bottom: 25px;
        // leading-trim: NONE;
        // line-height: 100%;
        // letter-spacing: 0%;
    }
    h4 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        text-align: left;
        color: #1A1A1A;

    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #555555;
        text-align: left;
    }
}

.right-btn {
    text-align: right !important;
    width: 100%;
}

.plain-border-button {
    button {
        border: 1px solid #0033EA;
        color: #0033EA;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
    }
}
.primary-button {
    margin-top: 25px;
    button {
        background-color: #0033EA;
        color: #FFFFFF;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
    }
}
.shelta-works {
    margin-bottom: 20px;
    h1 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 20px;
        color: #000000;
        text-align: left;
    }
    h2 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #3A3A3A;
        text-align: left;
    }
}
.box-1, .box-2, .box-3 {
    border-radius: 16px;
    padding: 32px;
}
.box-1 {
    background: #E6F0FA;
    
}
.box-2 {
    background: #FFB1001A;

}
.box-3 {
    background: #33CCB71A;
}
.client-say-holder {
    background: #F8F9FA;
    padding: 60px 15px;
    
}
.users-say {
    padding: 24px;
    background: #FFFFFF;
    border-radius: 16px;
    margin-bottom: 20px;
    min-height: 185px;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        text-align: left;
        color: #555555;

    }
}
.customer-say-item {
    align-items: center;
    margin-top: 16px;
    img {
        border-radius: 50px;
        border: 4px solid #EBEBEB;
    }
    h4 {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 0;
        // line-height: 28px;
        color: #0C0C0C;
        text-align: left;
        // display: flex;
    }
    small {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 30px;
        color: #3A3A3A;
        display: flex;
    }
}

.sip-holder {
    background: #F8F9FA1A;
}
.sip-item {
    border: 2px solid #EBEBEB;
    padding: 32px;
    border-radius: 16px;
    margin-bottom: 20px;
}

.letsbuild-holder {
    background: #E6F0FA;
    border-radius: 16px;
    padding: 50px 5px;
}

.letsbuild-holder {
    margin-bottom: 40px;
    h1 {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 40px;
        color: #1A1A1A;
        text-align: left;
        margin-bottom: 20px;
    }
    p {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        color: #555555;
        text-align: left;
        margin-bottom: 30px;
    }
}
.letsbuild-item {
    padding-left: 20px;
}

.pricing-item:hover {
    border: 2px solid #0033EA;
}
.pricing-item {
    border: 2px solid #EBEBEB;
    padding: 32px 24px;
    border-radius: 16px;
    margin-bottom: 25px;
    h1 {
        font-family: Lato;
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        color: #2B3352;
        text-align: left;
        margin-bottom: 15px;
    }
    h2 {
        text-align: left;
        font-family: Lato;
        font-weight: 700;
        font-size: 24px;
        line-height: 30px;
        color: #0033EA;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #555C74;
        text-align: left;
    }
    h4 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        color: #555C74;
        text-align: left;
    }
}

.top-options {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #000A2F;
    }
    button {
        background: #FFB100;
        color: #FFFFFF;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        width: fit-content;
        height: 30px;
        box-shadow: none;
        outline: 0;
        padding: 4px 8px;
        border: 8px;
    }
}

.price-discount {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        color: #555C74;
        text-decoration: line-through;
    }
    span {
        border: 1px solid #E5EBFF;
        background: #F5F7FE;
        color: #0033EA;
        font-family: Lato;
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        border-radius: 50px;
        padding: 4px 8px;
    }
}

@media (max-width: 767px) { 
    .household-holder {
        margin-top: 4rem;
    }
    .household-holder, .solved-problem {
        h3 {
            font-size: 31px;
            line-height: 50px;
        }
    }
    .house-join-mobile {
        width: 100%;
        margin-top: 50px;
        text-align: center !important;
    }
    .hosuehold-coever-2 {
        padding-top: 0px;
    }
    .household-image {
        margin-bottom: 40px;
    }
    .top-left {
       h6 {
            font-size: 14px;
            line-height: 20px;
       }
       h3 {
        font-size: 31px;
        line-height: 42px;
       }
       .join-btn {
            margin-top: 3rem;
            display: flex;
       }
    }
    .container > *:not(:last-child) {
        border-right: none;
    }
    .count-holder {
        margin-top: 4rem;
        h2 {
            font-size: 27px;
        }
        .count-item {
            margin-bottom: 32px;
        }
        div:not(:last-child) {
            border-right: none;
            padding-right: 0;
        }

    }
    .household-image {
        margin-top: 30px;
    }
    .letsbuild-holder {
        h1 {
            font-size: 31px;
            line-height: 44px;
        }
    }
}
</style>